export default __webpack_public_path__ + "static/media/training-illustration5.4ade80d3.svg";